
    import '/opt/buildhome/repo/packages/x/components/think/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["think-demo-basic","think-demo-status","think-demo-expand","think-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/think/index.zh-CN.md?type=demo')
};